export const enum EMenuType {
    CUSTOM = 'custom',
    CUSTOM_PAGE = 'custom_page',
    DASHBOARD = 'dashboard',
    POSTS_PAGE = 'posts_page',
    RSS = 'rss',
    MENU_COLLECTION = 'menu_collection',
    EVENT_CALENDAR = 'event_calendar',
}

export const enum ECalendarDisplayMode {
    LIST = 'list',
    CALENDAR = 'calendar',
}

export const enum ETimelineFilterType {
    RSS = 'rss',
    ISSUES = 'issues',
    NEWS = 'news',
    CALENDAR_EVENT = 'calendarEvent',
    USER_POST = 'userPost',
}

export const enum ETimelineIncludeType {
    ACCOUNT = 'account',
    FILES = 'files',
    IMAGES = 'images',
}

export const enum ETimelineOrder {
    IS_PINNED = 'isPinned',
    PUBLISHED_AT_DESC = '-publishAt',
}

export const enum ESearchResultTypes {
    CUSTOM_PAGE = 'customPage',
    POST_DETAIL = 'tlPost',
}

export const enum ERouteNames {
    HOME = 'home',
    DASHBOARD = 'dashboard',
    MENU_COLLECTION = 'menu-collection',
    POSTS_ARCHIVE = 'posts-archive',
    POSTS = 'posts',
    CUSTOM_PAGE = 'custom-page',
    RSS = 'rss',
    EVENT_CALENDAR = 'event-calendar',
    SITEMAP = 'sitemap',
    POST_DETAIL = 'post-detail',
    SEARCH = 'search',
    NOT_FOUND = 'not-found'
}

export const enum ELocale {
    CS = 'cs',
    SK = 'sk',
    DE_DE = 'de_DE',
    HU_HU = 'hu_HU',
    PL_PL = 'pl_PL',
    EN = 'en',
}
